import { Parameter } from '@src/main/modules/parameters/domain/parameters-management/parameter.interface';
import { ParameterRepository } from '@src/main/modules/parameters/domain/parameters-management/parameter.repository';
import { UpdateParameterRequest } from '@src/main/modules/parameters/infrastructure/dto/updateParameterRequest';
import {
  ParameterEntity,
  toParameter,
} from '@src/main/modules/parameters/infrastructure/entity/parameter.entity';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

const path = '/parameters';

export const createParameterHttpRepository = (tokenProvider: TokenProvider): ParameterRepository =>
  new ParameterHttpRepository(tokenProvider);

class ParameterHttpRepository implements ParameterRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) throw new Error('Authentication token is missing');
    return token;
  }

  async findAll(): Promise<Parameter[]> {
    const token = await this.getAuthToken();
    const response = await api.get<ParameterEntity[]>(`${path}/all`, token);
    return response.map(toParameter);
  }

  async update(id: string, parameter: UpdateParameterRequest): Promise<Parameter> {
    const token = await this.getAuthToken();
    const response = await api.put<ParameterEntity>(`${path}/${id}`, token, parameter);
    return toParameter(response);
  }
}
